import { render, staticRenderFns } from "./my-agents.vue?vue&type=template&id=568913db&scoped=true"
import script from "./my-agents.vue?vue&type=script&lang=js"
export * from "./my-agents.vue?vue&type=script&lang=js"
import style0 from "./my-agents.vue?vue&type=style&index=0&id=568913db&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568913db",
  null
  
)

export default component.exports